var _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location-filled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12971",
    "data-name": "Path 12971",
    d: "M12.5,3a5.274,5.274,0,0,0-5,5.5,5.809,5.809,0,0,0,1.007,3.3s.136.2.159.226L12.5,17l3.836-4.976c.02-.027.157-.223.157-.223v0A5.807,5.807,0,0,0,17.5,8.5,5.274,5.274,0,0,0,12.5,3Zm0,7.5a1.916,1.916,0,0,1-1.818-2,1.916,1.916,0,0,1,1.818-2,1.916,1.916,0,0,1,1.818,2,1.918,1.918,0,0,1-1.818,2Z",
    transform: "translate(-7.5 -3)",
    fill: "#600097"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "IconifyId-17e9079768a-d1151c-107",
    cx: 1.818,
    cy: 2,
    rx: 1.818,
    ry: 2,
    transform: "translate(3.182 3.5)",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.fec60723d850b53d23757097153628bb.svg";
export { ForwardRef as ReactComponent };